import ellipseShapeThree from "../../../assets/images/ellipse-shape-3.png";
import ellipseShapeFour from "../../../assets/images/ellipse-shape-4.png";
import sendIcon from "../../../assets/images/send-icon.svg";
import shape from "../../../assets/images/shape-2.png";
import { useAuth } from "../../context/auth-context";
import { useForm } from "react-hook-form";

const SubscribeSection = () => {
  const { subscribeUs ,loading } = useAuth();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    await subscribeUs(data);
    await reset();
  };

  return (
    <div className="bg-[#FEF5F5] lg:py-[75px] py-[50px] relative">
      <div className="container">
        <div className="bg-[#f3eaf6] lg:rounded-tl-[164px] rounded-tl-[100px] rounded-[24px] lg:py-[100px] py-[50px] px-4 relative z-20 sm:mr-6">
          <div className="absolute bottom-0 -left-[110px] overflow-hidden">
            <img alt="Shape" src={ellipseShapeFour} />
          </div>
          <h2 className="font-jakarta text-[32px] md:text-[44px] font-bold text-center">
            Subscribe to get information, latest news, and other
            <br />
            interesting offers about Bruvvi
          </h2>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="lg:mt-[120px] mt-[80px] flex items-start justify-center lg:gap-5 gap-3">
              <div className="w-full max-w-[535px]">
                <div className="relative">
                  <span className="absolute top-0 bottom-0 my-auto left-3 flex items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 26 26"
                      width={26}
                      height={26}
                      color={"#000000"}
                      fill={"none"}
                    >
                      <path
                        d="M7 8.5L9.94202 10.2394C11.6572 11.2535 12.3428 11.2535 14.058 10.2394L17 8.5"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M2.01576 13.4756C2.08114 16.5411 2.11382 18.0739 3.24495 19.2093C4.37608 20.3448 5.95033 20.3843 9.09883 20.4634C11.0393 20.5122 12.9607 20.5122 14.9012 20.4634C18.0497 20.3843 19.6239 20.3448 20.755 19.2093C21.8862 18.0739 21.9189 16.5411 21.9842 13.4756C22.0053 12.4899 22.0053 11.51 21.9842 10.5244C21.9189 7.45883 21.8862 5.92606 20.755 4.79063C19.6239 3.6552 18.0497 3.61565 14.9012 3.53654C12.9607 3.48778 11.0393 3.48778 9.09882 3.53653C5.95033 3.61563 4.37608 3.65518 3.24495 4.79062C2.11382 5.92605 2.08113 7.45882 2.01576 10.5243C1.99474 11.51 1.99474 12.4899 2.01576 13.4756Z"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <input
                    type="email"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value:
                          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        message: "Enter a valid email address",
                      },
                    })}
                    placeholder="Your email"
                    className="w-full py-3 pl-12 pr-4 focus:outline-none rounded-lg lg:h-[86px] h-[60px]"
                  />
                </div>
                {errors.email && (
                  <p className="text-red-500 text-sm mt-2">
                    {errors.email.message}
                  </p>
                )}
              </div>
              <button className="bg-primary lg:text-lg text-md lg:px-10 px-3 py-3 rounded-lg lg:h-[86px] h-[60px]" disabled={loading}>
               {loading ? (
            <>
              <svg aria-hidden="true" role="status" className="inline w-6 h-6 me-3 text-black animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#ffffff" />
                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
              </svg>
              Loading...
            </>
          ) :
            "Subscribe"
          } 
              </button>
            </div>
            <div className="absolute top-0 right-0 overflow-hidden -z-10">
              <img alt="Shape" src={ellipseShapeThree} />
            </div>
            <div className="absolute -top-3 -right-6 bg-black lg:w-[89px] lg:h-[89px] w-[60px] h-[60px] flex items-center justify-center p-3 rounded-full z-20 hidden sm:block">
              <img src={sendIcon} alt="Send Icon" />
            </div>
          </form>
        </div>
      </div>

      <div className="absolute bottom-0 right-0 overflow-hidden">
        <img alt="Shape" src={shape} />
      </div>
    </div>
  );
};

export default SubscribeSection;
